import http from '@/biz/http.mjs'
import {writeFileToDisk} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default specLevel => {
    const map = useMapContext()
    const {mapTypeCode, prjId, prjPatternId: patternId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const fmIds = [...map.selectedNodes]
            .filter(n => 'FM' === n.data.bizNodeType)
            .map(n => n.data.pkid)
        const vmIds = [...map.selectedNodes]
            .filter(n => 'VM' === n.data.bizNodeType)
            .map(n => n.data.pkid)

        const {blob, fileName} = await runAsync(
            () => http.post(
                '/ide/exportSpecByPattern',
                {fmIds, vmIds, patternId, prjId, specLevel, sVer}
            ),

            {action: '导出Spec'}
        )

        writeFileToDisk(blob, {suggestedName: fileName})
    }

    return {
        label: `导出Spec${specLevel}`,
        onClick,
    }
}
